import { post, get } from '../util/crmAxios';
import {UPDATE_PRODUCT_STATU} from "~/js/store/mutation-types";
import {getBaseUrl} from "~/js/util/config";

//export const getData = function(objParam){
//	return post('/token',{
//          grant_type: 'password',
//          username: 'admin@163.com',
//          password: '96E79218965EB72C92A5'
//      })
//}

    //新增产品数据
export const addProduct = (objParam = {}) => {
        return post('/ProductCenter/AddProduct', objParam);
    }


    //新增产品包数据
export const addProductPackage = (objParam = {}) => {
        return post('/ProductCenter/AddProductPackage', objParam);
    }


    //产品新增数据 2019
export const addOrModifyProduct = (objParam = {}) => {
    return post('/product/AddOrModifyProduct',objParam);
}

// //获取产品包列表数据
export const getProductPackageList = (objParam = {}) => {
    return post('/ProductCenter/GetProductPackageList', objParam);
}

//获取产品列表数据       2019
export const getData = (objParam = {}) => {
    //	let param = {"Where": {},"PageIndex": 1,"PageSize": 2,"OrderBy":"ProductID","SortCol":""};
    //	param = Object.assign(param,objParam);
    return post('/product/ProductSearch', objParam);
}
export const SearchMarketResearchList = (objParam = {}) => {
    //	let param = {"Where": {},"PageIndex": 1,"PageSize": 2,"OrderBy":"ProductID","SortCol":""};
    //	param = Object.assign(param,objParam);
    return post('/ERPMarketResearch/SearchMarketResearchList', objParam);
}


//根据产品id获取详情
export const GetProductInfoByID = (objParam = {}) => {
    let url = objParam.ProductPackageID ? '/ProductCenter/GetProductPackageByID' : '/ProductCenter/GetProductInfoByID'
    return get(url, objParam);
}

//根据产品id修改产品状态  2019

export const  FindProductById = (params) => get('product/FindProductById', params)

export const UpdateProductStatus = (objParam = {}) => {
    return get('/ProductCenter/UpdateProductStatus', objParam);
}



    //根据产品id修改更新产品列表数据
export const updateProductByMoudule = (objParam = {}) => {
        return post('/ProductCenter/UpdateProductByMoudule', objParam);
    }
    //根据产品包id修改更新产品列表数据
export const UpdateProductPackage = (objParam = {}) => {
        return post('/ProductCenter/UpdateProductPackage', objParam);
    }
    //根据产品id删除产品
export const deleteProduct = (objParam = {}) => {
    return get('/ProductCenter/DeleteProductByID', objParam);
}

// queryDictionariesByType

//产品数据字典
export const queryDictionariesByType = (objParam = {}) =>{
    return get(baseUrl + '/sales/common/queryDictionariesByType', objParam);
}

//产品数据字典
export const GetDictionaryByTypeId = (objParam = {}) => {
    return get('/Dictionary/GetDictionaryByTypeId', objParam);
}



//所属课程
export const GetDictionaryByParentId = (objParam = {}) => {
    return get('/Dictionary/GetDictionaryByParentId', objParam);
}

//调入产品包
export const AddBatchProductPackageDetial = (objParam = {}) => {
    return post('/ProductCenter/AddBatchProductPackageDetial', objParam);
}

//添加产品包
export const AddProductPackage = (objParam = {}) => {
    return post('/ProductCenter/AddProductPackage', objParam);
}

//新增公校
export const PublicSchoolAddEdit = (objParam = {}) => {
    return post('/ERPPublicSchool/PublicSchoolAddEdit', objParam);
}
// 分页查询
export const PublicSchoolSearch = (objParam = {}) => {
    return get('/ERPPublicSchool/PublicSchoolSearch', objParam);
}


//新增楼盘
export const HousesAddEdit = (objParam = {}) => {
    return post('/ERPHouses/HousesAddEdit', objParam);
}

//更新产品包信息
export const updateProductPackage = (objParam = {}) => {
    return post('/ProductCenter/UpdateProductPackage', objParam);
}

//根据产品包id修改产品包状态
export const UpdateProductPackageStatus = (objParam = {}) => {
    return post('/ProductCenter/UpdateProductPackageStatus', objParam);
}

//根据产品包id获取产品包详情
export const GetProductPackageByID = (objParam = {}) => {
        return get('/ProductCenter/GetProductPackageByID', objParam);
    }
    //删除产品包
export const DeleteProductPackage = (objParam = {}) => {
        return get('/ProductCenter/DeleteProductPackage', objParam);
    }
    //调入产品包右边列表
export const GetTuningProductPackageList = (objParam = {}) => {
        return post('/ProductCenter/GetTuningProductPackageList', objParam);
    }
    //根据课程包详情id删除产品和产品包
export const DeleteProductPackageDetial = (objParam = {}) => {
    return get('/ProductCenter/DeleteProductPackageDetial', objParam);
}

//获取产品优惠列表
export const GetProductDiscountList = (objParam = {}) => {
    return post('/ProductCenter/GetProductDiscountList', objParam);
}

//新增产品优惠
export const AddProductDiscount = (objParam = {}) => {
    return post('/ProductCenter/AddProductDiscount', objParam);
}


//更新产品优惠
export const UpdateProductDiscount = (objParam = {}) => {
    return post('/ProductCenter/UpdateProductDiscount', objParam);
}

//删除优惠内容
export const DeleteDiscount = (objParam = {}) => {
    return post('/ProductCenter/DeleteDiscount', objParam);
}

//优惠模糊查询
export const VagueSeachDiscountList = (objParam = {}) => {
        return post('/ProductCenter/VagueSeachDiscountList', objParam);
    }
    // 感兴趣的项目
export const interestedProject = (objParam) => get('/DataStru/GetCurrentUserCourseTypeList', objParam);


//更新状态优惠内容
export const UpdateDiscountStatus = (objParam = {}) => {
        return post('/ProductCenter/UpdateDiscountStatus', objParam);
    }
    // 获取所属项目字典表
export const GetDictionaryByParentIdAndType = (objParam = {}) => {
    return get('/Dictionary/GetDictionaryByParentIdAndType', objParam);
}

//新增产品性质关系
export const AddProductPropertyRelation = (objParam = {}) => {
    return post('/ProductCenter/AddProductPropertyRelation', objParam);
}
//删除产品性质关系
export const DeleteProductPropertyRelationByID = (objParam = {}) => {
    return post('/ProductCenter/DeleteProductPropertyRelationByID', objParam);
}
//获取产品性质关系列表
export const GetProductPropertyRelationList = (objParam = {}) => {
    return post('/ProductCenter/GetProductPropertyRelationList', objParam);
}
//获取登录用户对应的产品性质
export const GetDictionaryByProdunctProperty = (objParam = {}) => {
    return get('/ProductCenter/GetDictionaryByProdunctProperty', objParam);
}
//创建EDS班级
export const createEDSClass = (objParam = {}) => {
    return post('/ProductCenter/createClass', objParam);
}

//  课程管理列表
export const GetCourseList = (objParam = {}) => {
    return post('/ProductCenter/GetCourseList', objParam);
}

// 课程添加
export const AddCourse = (objParam = {}) => {
    return post('/ProductCenter/AddCourse', objParam);
}

// 课程修改
export const UpdateCourseByMoudule = (objParam = {}) => {
    return post('/ProductCenter/UpdateCourseByMoudule', objParam);
}

// 课程删除
export const DeleteCourseByID = (objParam = {}) => {
    return get('/ProductCenter/DeleteCourseByID', objParam);
}


// 客户了解渠道调研 保存
export const UpdateClueChannelResearch = (objParam = {}) => {
    return post('/ClueFollow/UpdateClueChannelResearch', objParam);
}

// 线索跟进页面,客户了解渠道调研 获取
export const GetClueChannelResearch = (objParam = {}) => {
    return get('/ClueFollow/GetClueChannelResearch', objParam);
}

export const PublicSchoolListSearch = (objParam = {}) => {
    return get('/ERPPublicSchool/PublicSchoolListSearch', objParam);
}

export const ProductSearch = (objParam = {}) => {
    return post('/product/ProductSearch', objParam);
}

export const ProductOnOffShelf = (objParam = {}) => {    // 产品上架下架
    return post('/product/ProductOnOffShelf', objParam);
}



let pre = getBaseUrl().match(/^.*-/), baseUrl;
if (pre === null) {
    baseUrl =  'http://test001-gw.myyixue.com/sales-tool/api';
} else {
    baseUrl = 'https://fuxi.songshuai.com/sales-tool/api'
}


